export default "__VITE_ASSET__DEILtpEn__"